import cardimg from "../../../../assets/visa-ms.svg";
import cardimg4 from "../../../../assets/usdt.svg";
import "./DefaultMethods.scss";
import {useUserStore} from "../../../../../modules/shop/user/store";

export interface IDefaultMethod {
    name: string,
    img: any,
    createUrl: string,
    preferMethod: string,
    paymentSystem: string,
    min: number,
    currency: string,
    buttonsData: {
        sum: number, info: string, line: number
    }[],
    iconCurrency: string
}

export const imagesMap: Record<string, string> = {
    cardimg: cardimg,
    cardimg4: cardimg4,
};

const DefaultMethods = ({setMethodPayment, setActivePopup, setActivePopupNotFully, paymentMethods}) => {
    const activeMethod = (method) => {
        setActivePopup(true)
        setMethodPayment(method)
    }
    const user = useUserStore(state => state.user)

    return (
        <div style={{marginBottom: "20px"}}>
            <h4 className="title-method">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--deposit-title-method)">
                    <path
                        d="M19 3H5a5.006 5.006 0 00-5 5h24a5.006 5.006 0 00-5-5zM0 16a5.006 5.006 0 005 5h14a5.006 5.006 0 005-5v-6H0v6zm7-.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
                        ></path>
                </svg>
                <p>Картки та крипта</p>
            </h4>
            <div style={{marginBottom: "20px"}} className="methods">
                {
                    paymentMethods?.map((method, idx) => {
                        return (
                            <div key={idx} onClick={() => activeMethod(method)} className="default-method-block d-flex">
                                <div className="default-method-name d-flex just-content-space-between">
                                    <p>{ method.name }</p>
                                </div>
                                <img src={ imagesMap[method.img] } alt={ method.name } />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default DefaultMethods;